import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefConditionSearchDomesticKobe = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      colId: 'selectBox',
      headerName: '',
      headerCheckboxSelection: () => true,
      checkboxSelection: () => true,
      resizable: false,
      suppressMenu: true,
      suppressSizeToFit: true,
      minWidth: 50,
      maxWidth: 50,
    },
    {
      field: 'customer1',
      headerName: t('condition.customer1'),
      headerTooltip: t('condition.customer1'),
      width: 100,
    },
    {
      field: 'customer1Name',
      headerName: t('condition.customerName1'),
      headerTooltip: t('condition.customerName1'),
      tooltipField: 'customer1Name',
      width: 400,
    },
    {
      field: 'standard',
      headerName: t('millSheet.standard'),
      headerTooltip: t('millSheet.standard'),
      tooltipField: 'standard',
      width: 100,
    },
    {
      field: 'sizeDisplay',
      headerName: t('millSheet.size'),
      headerTooltip: t('millSheet.size'),
    },
  ];

  return colDefs;
};

export default useColdefConditionSearchDomesticKobe;
